import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../helpers/api';
import {
  FETCH_INVENTORY_REPORT,
} from './actionTypes';
import {
  fetchInventoryReportSuccess,
  fetchInventoryReportFail,
} from './actions';

function* fetchInventoryReportSaga({ payload }) {
  try {
    const { months, granularity } = payload || {};
    const params = new URLSearchParams();
    if (months != null) params.append('months', months);
    if (granularity) params.append('granularity', granularity);
    const query = params.toString();
    const { data } = yield call(api.get, `inventory${query ? `?${query}` : ''}`);
    yield put(fetchInventoryReportSuccess(data.response));
  } catch (error) {
    console.error('Error fetching inventory report:', error);
    yield put(fetchInventoryReportFail(error.response?.data?.message || 'Failed to fetch inventory report'));
  }
}

function* reportingInventorySaga() {
  yield takeLatest(FETCH_INVENTORY_REPORT, fetchInventoryReportSaga);
}

export default reportingInventorySaga;
